<template>
    <el-form-item>
        <el-select v-model="selfStatus" placeholder="Status of Payment" clearable @change="dataChange">
            <el-option
                    v-for="item in [{value:1,label:'Pending'},{value:2,label:'Paid'}]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
    </el-form-item>
</template>
<script>
    export default {
        name: "PaymentStatusFilter",
        props: {
            status: {required: false, type: Number},
        },
        data() {
            return {
                selfStatus: this.selfStatus ? this.selfStatus : this.status
            }
        },
        methods: {
            dataChange(val) {
                this.$emit('update:status', val)
            }
        }
    }
</script>

<style scoped>

</style>
